import { loadModal } from '../../AsyncLoader';
import SyosPageComponent from '../SyosPageComponent';

const SyosAjaxErrorModal = {
  open(syosController) {
    loadModal().then((Modal) => {
      Modal.alert({
        root: syosController.$el,
        title: SyosPageComponent.ajaxErrorModalTitle,
        bodyContents: SyosPageComponent.ajaxErrorModalMessage,
      });
    });
  },
};

export default SyosAjaxErrorModal;



// WEBPACK FOOTER //
// ./src/syos/modals/SyosAjaxErrorModal.js